module.exports = __webpack_public_path__ + "img/double-left-arrow.4a32ae4a.svg";